export const forgotPassword = {
    title: '忘记密码',
    content: '请输入您的注册邮箱',
    button: '发送',
    titleSwal: '已发送密码重置链接',
    contentSwal: '请检查您的电子邮件并检查重置密码链接',
};
